// extracted by mini-css-extract-plugin
export default {"opener":"opener--IJeso","popoverContainer":"popoverContainer--u9Zig","frontArrow":"frontArrow--_N5y6","backArrow":"backArrow--eSK7B"};